import { ApolloLink } from 'apollo-boost';

const ignoredErrors = [new RegExp('NUMBER OF SERVICES MISMATCH WITH SSR SEAT')];

const ignoredErrorsLink = new ApolloLink((operation, forward) => {
	return forward(operation).map(response => {
		if (!!response?.errors?.length) {
			let ignoredErrorsCount = 0;

			response.errors.forEach(error => {
				if (ignoredErrors.some(regError => regError.test(error.message))) {
					ignoredErrorsCount++;
				}
			});

			if (response.errors.length === ignoredErrorsCount) {
				delete response.errors;
			}
		}

		return response;
	});
});

export default ignoredErrorsLink;
